import type { VitaDocumentCvFragment } from '@xing-com/crate-lebenslauf-graphql';

export const convertNullValues = (obj: any): VitaDocumentCvFragment => {
  if (obj === null) {
    obj = '';
  }

  if (typeof obj === 'object') {
    for (const key in obj) {
      obj[key] = convertNullValues(obj[key]);
    }
  }

  return obj;
};
